import styled from 'styled-components';

import { Link } from 'components/Link';
import { IdealistLogo } from 'components/Logo/IdealistLogo';
import { NoAmp } from 'containers/NoAmp';
import { colors, gutterWidth, namedBreakpoints } from 'theme';

import { MobileSearchMenu } from './MobileSearchMenu';
import { PageHeaderSearchInputs } from './PageHeaderSearchInputs';
import { useMainSearchMenu } from './useMainSearchMenu';

type Props = {
  onSearch: (arg0: {
    query?: string;
    type?: string;
    searchType?: string;
  }) => void;
  defaultSearchType?: DefaultSearchType;
  navSection: 'MAIN' | 'STAFF';
  qaId?: string;
  searchFrom?: string;
  searchOpen: boolean;
  searchMode?: boolean;
  toggleSearch: (searchOpen: boolean) => void;
};

const DesktopSearchMenuContainer = styled.div`
  display: none;

  @media (min-width: ${namedBreakpoints.mdUp}) {
    padding: 16px ${gutterWidth / 2}px;
    display: flex;
    background-color: ${colors.white};
    border-top: 1px solid ${colors.inputGrey};
  }

  @media print {
    display: none;
  }
`;

const LogoContainer = styled.div`
  margin-right: 40px;
`;

const InputsContainer = styled.div`
  flex-grow: 1;
`;

export function PageHeaderSearchMenu({
  onSearch,
  defaultSearchType,
  navSection,
  qaId = 'page-header-search-menu',
  searchFrom,
  searchOpen,
  searchMode,
  toggleSearch,
}: Props) {
  const isStaff = navSection === 'STAFF';

  const mainProps = useMainSearchMenu(
    searchFrom,
    searchMode,
    defaultSearchType,
  );

  return (
    <NoAmp>
      <MobileSearchMenu
        onClose={() => toggleSearch(false)}
        onSearch={() => toggleSearch(false)}
        searchMode={Boolean(searchMode)}
        searchOpen={searchOpen}
        navSection={navSection}
        defaultSearchType={defaultSearchType}
        selectedType={mainProps.selectedType}
        listingTypes={mainProps.listingTypes}
        clearSearchInput={mainProps.clearSearchInput}
        search={mainProps.search}
        query={mainProps.query}
        // @ts-expect-error Fix SearchLocation type
        searchLocation={mainProps.searchLocation}
        // @ts-expect-error Fix ListingType type
        setListingType={mainProps.setListingType}
        setUserQuery={mainProps.setUserQuery}
        onLocationChange={mainProps.onLocationChange}
        showPopularSearches
      />
      <DesktopSearchMenuContainer data-qa-id={qaId}>
        <LogoContainer>
          <Link
            href={isStaff ? '/staff' : '/'}
            title={`Idealist${isStaff ? ' Staff' : ''}`}
            data-qa-id="search-menu-logo-link"
          >
            <IdealistLogo
              withText
              height={{ mobile: 36, desktop: 48 }}
              withStaffMarker={isStaff}
            />
          </Link>
        </LogoContainer>
        <InputsContainer>
          <PageHeaderSearchInputs
            onSearch={onSearch}
            selectedType={mainProps.selectedType}
            listingTypes={mainProps.listingTypes}
            clearSearchInput={mainProps.clearSearchInput}
            search={mainProps.search}
            query={mainProps.query}
            searchLocation={mainProps.searchLocation}
            setListingType={mainProps.setListingType}
            setQuery={mainProps.setUserQuery}
            onLocationChange={mainProps.onLocationChange}
          />
        </InputsContainer>
      </DesktopSearchMenuContainer>
    </NoAmp>
  );
}
